import { useState } from 'react';
import type { ChangeEventHandler } from 'react';

interface PasswordInputProps {
  id: string;
  placeholder: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
}

function PasswordInput({
  id,
  placeholder,
  value,
  onChange,
  required = false,
}: PasswordInputProps) {
  const [isVisible, setIsVisible] = useState(false);
  const actionLabel = isVisible ? 'Hide password' : 'Show password';

  return (
    <div className="password-input-wrapper">
      <input
        id={id}
        type={isVisible ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
      />
      <button
        type="button"
        className="password-visibility-button"
        aria-label={actionLabel}
        aria-pressed={isVisible}
        onClick={() => setIsVisible((visible) => !visible)}
      >
        {isVisible ? (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 3l18 18M10.6 10.7a2 2 0 002.7 2.7M9.9 4.2A10.8 10.8 0 0112 4c5.5 0 9 5.2 9 5.2a15 15 0 01-2.2 2.7M6.2 6.2C4.1 7.6 3 9.2 3 9.2S6.5 16 12 16c1.4 0 2.7-.4 3.8-1" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 12s3.5-6.8 9-6.8 9 6.8 9 6.8-3.5 6.8-9 6.8S3 12 3 12z" />
            <circle cx="12" cy="12" r="2.5" />
          </svg>
        )}
      </button>
    </div>
  );
}

export default PasswordInput;
